<template>
  <div>
    <h2 class="intro-y text-lg font-medium mt-10">{{ t('pageTitle') }}</h2>
    <dataList :settings="{
              dataGetterPath: 'automations/getAutomations',
              loadDataPath: 'automations/loadAutomations',
              deleteDataItemPath: 'automations/deleteAutomation',
              createItemRoute: 'automation-add',
              updateItemRoute: 'automation-edit',
              addButtonName: t('addTaskBtn'),
              firstNameField: 'NAME',
              secondNameField: 'TYPE',
              deleteConfirmationContent: t('deleteConfirmContent')
            }"/>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'AutomationsList',
  setup() {
    // локализация
    const { t } = useI18n({
      messages: {
        ar: {
          pageTitle: 'الالية',
          addTaskBtn: 'أضف المهمة',
          deleteConfirmContent: 'هذه المهمة'
        },
        en: {
          pageTitle: 'Automation',
          addTaskBtn: 'Add task',
          deleteConfirmContent: 'this task'
        },
        ru: {
          pageTitle: 'Автоматизация',
          addTaskBtn: 'Добавить задание',
          deleteConfirmContent: 'этим заданием'
        }
      }
    })

    return { t }
  }
})
</script>
